// Static lookup of poolId -> official DC DPR hours page.
//
// Copied verbatim from the verified `dprUrl` values in
// research/pool-locations-links.json (compiled 2026-05-29; each URL confirmed
// to return HTTP 200 on dpr.dc.gov). This is static reference data, so we embed
// it in the bundle rather than fetching it at runtime.
const DPR_HOURS_URLS: Record<string, string> = {
  banneker: "https://dpr.dc.gov/page/banneker-pool",
  "happy-hollow": "https://dpr.dc.gov/page/happy-hallow-childrens-pool",
  "park-view": "https://dpr.dc.gov/page/park-view-childrens-pool-1",
  francis: "https://dpr.dc.gov/page/francis-pool",
  "volta-park": "https://dpr.dc.gov/page/volta-park-pool",
  hearst: "https://dpr.dc.gov/page/hearst-pool",
  upshur: "https://dpr.dc.gov/page/upshur-pool",
  "harry-thomas": "https://dpr.dc.gov/page/harry-thomas-sr-pool",
  "langdon-park": "https://dpr.dc.gov/page/langdon-park-pool",
  "theodore-hagans": "https://dpr.dc.gov/page/theodore-hagans-pool",
  kenilworth: "https://dpr.dc.gov/page/kenilworth-pool",
  "ridge-road": "https://dpr.dc.gov/page/ridge-road-pool",
  "woody-ward": "https://dpr.dc.gov/page/woody-ward-pool",
  anacostia: "https://dpr.dc.gov/page/anacostia-pool",
  "fort-stanton": "https://dpr.dc.gov/page/fort-stanton-pool",
  "lincoln-capper": "https://dpr.dc.gov/page/lincoln-capper-childrens-pool",
  "oxon-run": "https://dpr.dc.gov/page/oxon-run-pool-01",
  "marie-reed-indoor": "https://dpr.dc.gov/page/marie-reed-aquatic-center",
  "wilson-indoor": "https://dpr.dc.gov/page/wilson-aquatic-center",
  "takoma-indoor": "https://dpr.dc.gov/page/takoma-aquatic-center",
  "turkey-thicket-indoor": "https://dpr.dc.gov/page/turkey-thicket-aquatic-center",
  "rumsey-indoor": "https://dpr.dc.gov/page/dr-william-h-rumsey-aquatic-center",
  "deanwood-indoor": "https://dpr.dc.gov/page/deanwood-aquatic-center",
};

/** Official DC DPR hours page for a pool, or undefined if we don't have one. */
export function dprHoursUrl(poolId: string): string | undefined {
  return DPR_HOURS_URLS[poolId];
}
